import config from "config/config";

const primary = {
  bg: "primary.900",
  bgImage: {
    base: "none",
    md: `url(${config.staticUrl}/i/airhelp-plus/ahplus-landing-page-bg-fragment-triangles-02.svg)`,
  },
  bgRepeat: "no-repeat",
  bgPosition: "right",
  bgSize: "contain",
};

const airhelpPlus = {
  bg: "primary.900",
  bgImage: {
    base: "none",
    md: `url(${config.staticUrl}/i/homepage/decoration-img-triangles.svg)`,
    lg: `url(${config.staticUrl}/i/homepage/decoration-img-colored-triangles-phone-lg.svg)`,
    "2xl": `url(${config.staticUrl}/i/homepage/decoration-img-colored-triangles-phone.svg)`,
  },
  bgRepeat: "no-repeat",
  bgPosition: "right bottom",
};

const brasil = {
  bg: "primary.900",
  bgImage: {
    base: "none",
    md: `url(${config.staticUrl}/i/homepage/decoration-img-triangles.svg)`,
    lg: `url(${config.staticUrl}/i/brasil/colored-triangles-phone-sm-br.png)`,
    "2xl": `url(${config.staticUrl}/i/brasil/colored-triangles-phone-lg-br.png)`,
  },
  bgRepeat: "no-repeat",
  bgPosition: "right bottom",
  bgSize: "contain",
};

const greyWhite = { bgGradient: "linear(to-b,  greyscale.300 50%, #ffffff 0)" };

const whiteGrey = { bgGradient: "linear(to-b, #ffffff 50%, greyscale.300 0)" };

const whiteLightGrey = { bgGradient: "linear(to-b, #ffffff 50%, greyscale.200 0)" };

const transperentGrey = { bgGradient: "linear(to-b, transparent 50%, greyscale.300 0)" };

const grey = {
  bg: "greyscale.300",
};

const lightGrey = {
  bg: "greyscale.200",
};

const greyHills = {
  bg: "greyscale.300",
  bgImage: {
    base: "none",
    lg: `url(${config.staticUrl}/i/homepage/decoration-img-triangles-2.svg)`,
  },
  bgRepeat: "no-repeat",
  bgPosition: "-100px 40px",
};

const people = {
  bgImage: {
    base: "none",
    md: `url(${config.staticUrl}/i/homepage/airhelp_hero.jpeg)`,
  },
  bgSize: "auto 575px",
  bgRepeat: "no-repeat",
  bgPosition: { md: "50vw 100%", lg: "58vw 50%" },
};

const summer = {
  bgImage: {
    base: "none",
    md: `url(${config.staticUrl}/i/homepage/airhelp-summer.jpeg)`,
  },
  bgSize: "contain",
  bgRepeat: "no-repeat",
  bgPosition: { md: "50vw 100%", lg: "58vw 100%" },
};

const coloredHills = {
  bg: "primary.900",
  bgImage: {
    base: "none",
    lg: `url(${config.staticUrl}/i/homepage/decoration-img-triangles.svg)`,
  },
  bgRepeat: "no-repeat",
  bgPosition: "right bottom",
};

const none = {
  bg: "transperent",
};

const bgStyles = {
  primary,
  "airhelp-plus": airhelpPlus,
  brasil,
  "grey-white": greyWhite,
  "white-grey": whiteGrey,
  "transperent-grey": transperentGrey,
  grey,
  "grey-hills": greyHills,
  "colored-hills": coloredHills,
  people,
  summer,
  none,
  lightGrey,
  whiteLightGrey,
};

export type Backgrounds = keyof typeof bgStyles;

export default bgStyles;
